import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, OutlookDiscoveredMailboxesResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof OutlookDiscoveredMailboxesResponseDataSchema>>

export const discoverOutlookMailboxesQuery = (outlookAccountId: string) => {
  return queryOptions({
    queryKey: ["discoverOutlookMailboxes", outlookAccountId],
    queryFn: async () => {
      const response = await axios.post<Response>(`/integrations/outlook/mailboxes/discover`, {
        outlookAccountId,
      })

      return response.data.data
    },
  })
}
